import React from 'react';
import AddOrEditLogicoProcess from './AddOrEditLogicoProcessComponent';
import AddOrEditLogicoProcessComponent from './AddOrEditLogicoProcessComponent';

export default (props) => {
    return <AddOrEditLogicoProcessComponent location={props.location} />;
}
